/**
 * Created by Mohamed on 5/30/2016.
 */
(function (angular, BaseForm, TeamScheduleAPI) {

    var _tsService;
    var _tsToastService;

    // To be used when reseting the form (Discard button)
    var _settingsData;

    var TSEmployerSettingsForm = function (scope, hUser, $state) {
        var self = this;
        var formName = "ts-employer-settings";
        var _protected = BaseForm.call(self, formName, scope);

        self.data = {};
        self.errors = {};

        self.save = function () {

            self.errors = {};

            if (self.validator.validate()) {

                self.saving = true;

                _tsService.getActiveBrand()
                    .then(function(brand) {

                        var dataToSave = $.extend({}, self.data);
	                    if (!dataToSave.max_weekly_hours_enabled) {
		                    dataToSave.max_weekly_hours = 0;
		                    self.data.max_weekly_hours = 0;
	                    }
	                    delete dataToSave.max_weekly_hours_enabled;
	                    if (!dataToSave.max_daily_hours_enabled) {
		                    dataToSave.max_daily_hours = 0;
		                    self.data.max_daily_hours = 0;
	                    }
	                    delete dataToSave.max_daily_hours_enabled;
	                    if (!self.data.max_daily_hours) {
		                    delete self.data.max_daily_hours;
		                    dataToSave.max_daily_hours = 0;
	                    }
	                    if (!self.data.max_weekly_hours) {
		                    delete self.data.max_weekly_hours;
		                    dataToSave.max_weekly_hours = 0;
	                    }

                        dataToSave.schedule_changes_notification = (dataToSave.schedule_changes_notification)? 'SEND_TO_ALL': 'SEND_TO_AFFECTED';

                        TeamScheduleAPI.saveBrandSettings(brand.id, dataToSave)
                            .then(function(res) {
                                _settingsData = $.extend({}, self.data);
	                            checkIfDailyWeeklyEnabled();
	                            _tsToastService.showSuccess("Your settings have been successfully saved");
	                            self.saving = false;
	                            scope.$digest();
                            }, function(err) {
                                console.error(err);
                                _tsToastService.showError("Something went wrong... ", "Refresh", function () {
                                    window.location = window.location;
                                });
                                self.saving = false;
                                scope.$digest();
                            });
                    });
            }
        };

        self.reset = function () {
            self.data = $.extend({}, _settingsData);
        };

        self.load = function () {
            _tsService.getActiveBrand()
                .then(function(brand) {
                    TeamScheduleAPI.getBrandSettings(brand.id)
                        .then(function(settings) {
                            settings.schedule_changes_notification = (settings.schedule_changes_notification == 'SEND_TO_ALL');
                            _settingsData = $.extend({}, settings);
                            self.data = settings;
	                        checkIfDailyWeeklyEnabled();
                            scope.$digest();
                        });
                });

        };

        self.validator.validateCustom = function(field, optionsField, rule, showError) {

            var name = field.attr("name");
            var value = self.validator.getFieldValue(field);

            switch (rule.name) {
                case "weekly_hours":

                    if (self.data.max_weekly_hours_enabled) {
                        if (!value || isNaN(value) || value < 0 || value > 99) {
                            self.validator.validation[name].errors[rule.name] = true;
                            return false;
                        }
                    }

                    break;

                case "daily_hours":

                    if (self.data.max_daily_hours_enabled) {
                        if (!value || isNaN(value) || value < 0 || value > 24) {
                            self.validator.validation[name].errors[rule.name] = true;
                            return false;
                        }
                    }

                    break;
            }

            return true;
        };

	    var checkIfDailyWeeklyEnabled = function () {
		    if (self.data) {
			    if (self.data.max_daily_hours) {
				    self.data.max_daily_hours_enabled = true;
			    }
			    else {
				    self.data.max_daily_hours_enabled = false;
				    delete self.data.max_daily_hours;
			    }
			    if (self.data.max_weekly_hours) {
				    self.data.max_weekly_hours_enabled = true;
			    }
			    else {
				    self.data.max_weekly_hours_enabled = false;
				    delete self.data.max_weekly_hours;
			    }
		    }
	    };

        self.load();
    };

    angular
        .module('harriApp')
        .service('TSEmployerSettingsForm', ["TeamScheduleService", "TSToastService", function (TeamScheduleService, TSToastService) {
            return function (scope) {
                _tsService = TeamScheduleService;
                _tsToastService = TSToastService(scope);
                return new TSEmployerSettingsForm(scope);
            }
        }]);

})(angular, BaseForm, TeamScheduleAPI);
